import api from './api';
const authService = {
  register: (data) => api.post('/accounts/register/', data).then(r => r.data),
  getProfile: ()   => api.get('/accounts/profile/').then(r => r.data),
  updateProfile: (data) => api.patch('/accounts/profile/', data).then(r => r.data),
};
export default authService;